import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ForgeIconButtonModule, ForgeIconModule } from '@tylertech/forge-angular';
import { ImageDetails, InmatesService } from "@tylertech/cj-inmate-search-angular-sdk";
import { IconRegistry } from '@tylertech/forge';
import { tylIconKeyboardArrowRight } from '@tylertech/tyler-icons/standard';
import { SharedModule } from 'src/app/modules/shared/shared.module';

import { DocInmate } from 'src/app/models/doc-inmate.model';
import { InmateStatusClassPipe } from 'src/app/utils/_pipes/inmate-status-class.pipe';
import { FACILITY_NAMES, getLocationDisplay } from 'src/app/utils/facility-names';
import { InstanceConfigService } from 'src/app/core/services/instance-config.service';
import { toMugshotDetails } from 'src/app/utils/image.utils';

@Component({
  selector: 'doc-inmate-card',
  standalone: true,
  imports: [CommonModule, ForgeIconButtonModule, ForgeIconModule, SharedModule, InmateStatusClassPipe],
  templateUrl: './doc-inmate-card.component.html',
  styleUrls: ['./doc-inmate-card.component.scss']
})
export class DocInmateCardComponent implements OnChanges {
  @Input() inmate!: DocInmate;

  protected mugshotImageDetails: ImageDetails | null = null;

  constructor(
    private readonly _inmateService: InmatesService,
    private readonly _instanceConfigService: InstanceConfigService
  ) {
    IconRegistry.define([tylIconKeyboardArrowRight]);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const hideMugshots = this._instanceConfigService.inmateVisibilitySnapshot?.hideMugShots ?? false;

    if (!hideMugshots && changes.inmate) {
      this.loadMugshot();
    }
  }

  get hideMugShots(): boolean {
    return this._instanceConfigService.inmateVisibilitySnapshot?.hideMugShots ?? false;
  }

  private loadMugshot(): void {
    if (!this.inmate?.instanceId || !this.inmate?.id || !this._inmateService) {
      this.mugshotImageDetails = null;
      return;
    }
    this._inmateService.getInmateImage(this.inmate.instanceId, this.inmate.id, (this.inmate as any).imageServiceClientId).subscribe({
      next: (imageDetails) => {
        this.mugshotImageDetails = toMugshotDetails(imageDetails);
      },
      error: (err) => {
        this.mugshotImageDetails = null;
        if (err.status === 404) return;
        console.error(err);
      }
    });
  }

  protected onImageError(): void {
    this.mugshotImageDetails = null;
  }

  get locationDisplay(): string {
    return getLocationDisplay(this.inmate?.location);
  }

  get statusDisplay(): string {
    const sup = this.inmate?.supervisionStatus;
    const supName = typeof sup === 'object' && sup !== null
      ? (sup.supervisionStatusName || sup.supervisionStatus)
      : (typeof sup === 'string' ? sup : undefined);
    return this.inmate?.custodyStatus || this.inmate?.status || supName || 'Unknown';
  }
}